import { useTrackVersionUpgrade } from '@euler/functions/useTrackVersionUpgraded';
import { memo } from 'react';

export const TrackVersionUpgrade = memo(() => {
  useTrackVersionUpgrade();
  return null;
});
